





















































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SheetListTab from "../../components/SheetListTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Student, SheetResult, Curriculum } from "../../modules/teacher/ResultStudentTwenty"


export interface Data {
  tabNo: number
  sheet_group_key: string
  student_num: string
  nendo: string
  student: Student
  nendos: any[]
  curriculums: Curriculum[]
  sheetResults: SheetResult[]
  isStudentSite: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "sheet-list-tab": SheetListTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 3,
      sheet_group_key: "",
      student_num: "",
      nendo: "",
      student: new Student({}),
      nendos: [],
      curriculums: new Array<Curriculum>(),
      sheetResults: new Array<SheetResult>(),
      isStudentSite: window.location.href.indexOf("student_site") != -1,
      errors: [],
    });

    /******************************
     * 評定平均を計算
     ******************************/

    const avgRating = (subject_id: string): string => {
      const ratings = state.sheetResults.filter(x => x["rating_info"][subject_id] && x["rating_info"][subject_id] != "-").map(x => x["rating_info"][subject_id]);
      const avg = Number(Math.round(Common.sumArray(ratings) * 10 / ratings.length)) / 10;
      return ratings.length > 0 ? avg.toString() : "-";
    };

    /******************************
     * 学年を画面表示文言にコンバート
     ******************************/

    const gradeNameHeader = (grade: number) => {
      let gradeName = "";
      if(grade == Common.GradeEnum.Chu1){
        gradeName = "中学1年";
      }else if(grade == Common.GradeEnum.Chu2){
        gradeName = "中学2年";
      }else if(grade == Common.GradeEnum.Chu3){
        gradeName = "中学3年";
      }else if(grade == Common.GradeEnum.Kou1){
        gradeName = "高校1年";
      }else if(grade == Common.GradeEnum.Kou2){
        gradeName = "高校2年";
      }else if(grade == Common.GradeEnum.Kou3){
        gradeName = "高校3年";
      }
      return gradeName;
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      const condition = {student_num: state.student_num, sheet_group_key: state.sheet_group_key, nendo: state.nendo}
      await http.get(`/api/result_student_twenty?${Common.BuildQuery(condition, 'search_result')}`).then(response => {
        state.student = new Student(response.data.student);
        state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));
        state.sheetResults = response.data.sheet_results.map((x: any) => new SheetResult(x));
        state.nendos = [];
        response.data.nendos.forEach((x: any) => {state.nendos.push({value: x, text: x});});
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 年度変更時
     ******************************/

    const nendoChange = async () => {
      context.root.$router.push({path: `/student_site/result_student_twenty`, query: {nendo: state.nendo}}).catch(() => {});
      location.reload();
    };

    /******************************
     * 生徒一覧に遷移
     ******************************/

    const toResultStudentList = () => {
      context.root.$router.push(`/teacher_site/result_student_list/${context.root.$store.state.resultStudentDetailSheetGroupKey}/${context.root.$store.state.resultStudentDetailRoomId}`).catch(() => {});
    };

    /******************************
     * 諸テスト成績に遷移
     ******************************/

    const toVarious = () => {
      if(!state.isStudentSite){
        context.root.$router.push(`/teacher_site/result_student_various`).catch(() => {});
      }else{
        context.root.$router.push({path: `/student_site/result_student_various`, query: {nendo: state.nendo}}).catch(() => {});
      }
    };

    /******************************
     * 分布表に遷移
     ******************************/

    const toDistribution = (sheetResult: SheetResult) => {
      if(!state.isStudentSite){
        context.root.$router.push({path: `/teacher_site/result_distribution_list/${sheetResult.sheet_group_key}/${state.student.room_id}`}).catch(() => {});
      }else{
        context.root.$router.push({path: `/student_site/result_distribution_list/${sheetResult.sheet_group_key}/${state.student.room_id}`, query: {nendo: state.nendo}}).catch(() => {});
      }
    };

    /******************************
     * 画像一覧画面へ遷移
     ******************************/

    const toResultStudentImageList = () => {
      context.root.$store.commit("setStudentNum", state.student_num);

      if(!state.isStudentSite){
        context.root.$router.push(`/teacher_site/result_student_image_list/${context.root.$store.getters.getCurrentNendo()}`).catch(() => {});
      }else{
        context.root.$router.push(`/student_site/result_student_image_list/${state.nendo}`).catch(() => {});
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      if(state.isStudentSite && !context.root.$store.state.student_num){
        window.location.href="/#/";
        return;
      }
      state.student_num = context.root.$store.state.student_num;
      state.sheet_group_key = context.root.$route.query.sheet_group_key ? context.root.$route.query.sheet_group_key.toString() : "";
      state.nendo = context.root.$route.query.nendo ? context.root.$route.query.nendo.toString() : "";
      await search()
    });

    return {
      ...toRefs(state),
      avgRating,
      gradeNameHeader,
      nendoChange,
      toResultStudentList,
      toVarious,
      toDistribution,
      toResultStudentImageList,
    }
  }
});
